<dashboardnav>
  
  <cradua-accountablefunction
  [functions]="functions$ | async"
  [accountableFunctions]="accountableFunctions$ | async"

  (changeEmit)="onSubmitAccountableFunction($event)"
  (deleteEvent)="onDeleteAccountableFunction($event)"

  *ngIf="
  !(isLoadingFunction$ | async ) &&
  !(isLoadingAccountableFunction$ | async )
  "
  >
</cradua-accountablefunction>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingFunction$ | async ) ||
  (isLoadingAccountableFunction$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
